import { SubCourseTopicActions } from '../ActionTypes';

export const setAllSubCourseTopics = (subCourseTopics) => ({
    type: SubCourseTopicActions.SetAll,
    subCourseTopics
});
